<template>
  <div id="contenedor-main-reportes-contratos-consulta">
    <!-- ToolBar -->
    <div>
      <tool-bar
        :listaContratos="getContratos"
        :filtros="filtros">
      </tool-bar>
    </div>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <div>
    </div>
    <listado
      v-if="!$apollo.loading"
      :listado="listadoContratos">
    </listado>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosReportesConsulta.gql';
import mixAvProgramado from '@/helpers/calculos/mixAvProgramado';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'DefaultReportesContratosConsulta',
  mixins: [mixAvProgramado],
  components: {
    ToolBar,
    Listado,
  },
  data() {
    return {
      buscarTexto: '',
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  apollo: {
    contratosReportesConsulta: {
      query: CONTRATOS,
      variables() {
        return {
          ejercicio: this.filtros.ejercicio,
        };
      },
    },
  },
  // async mounted() {
  //   await this.$apollo.queries.contratosReportesConsulta.refetch({
  //     ejercicio: this.filtros.ejercicio,
  //   });
  //   const filtrosGuardados = JSON.parse(this.mixGetFiltro('consulta-contratos'));
  //   if (filtrosGuardados) {
  //     this.filtros = JSON.parse(this.mixGetFiltro('consulta-contratos'));
  //   }
  // },
  computed: {
    getContratos() {
      if (!this.contratosReportesConsulta) return [];
      return this.contratosReportesConsulta
      // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    listadoContratos() {
      if (!this.contratosReportesConsulta) return [];
      const contratos = this.contratosReportesConsulta;
      const nuevosContratos = contratos.map((contrato) => contrato);
      return nuevosContratos
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        // Sumar el total de anticipo
        .map((contrato) => ({
          ...contrato,
          totalAnticipo: contrato.anticipos.reduce((val, { total }) => val + total, 0),
        }))
        // Sacar el ultimo reporte
        .map((contrato) => {
          const ultimoReporte = contrato.reportesFisicos[0];

          if (ultimoReporte) {
            ultimoReporte.avanceDiferencia = (ultimoReporte.avanceProgramado
            - ultimoReporte.avanceFisico);
          }

          return {
            ...contrato,
            ultimoReporte,
          };
        })
        // poner la supervision externa
        .map((contrato) => ({
          ...contrato,
          supervisionExterna: contrato.contratosRelacionados
            .find(({ esSupervisionExterna }) => esSupervisionExterna === true),
        }))
        .map((contrato) => ({
          ...contrato,
          avanceProgramado: this.mixCalcularAvanceProgramado(new Date().toISOString().slice(0, 10),
            contrato),
        }))
        .slice()
        // .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        .sort((a, b) => a.orden - b.orden)

        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => {
          const { avancesFisicos } = contrato;
          if (avancesFisicos.length <= 0) {
            return {
              ...contrato,
            };
          }

          const ultimosConceptosReportados = [];

          const conceptosIds = [...new Set(avancesFisicos.map(({ idConcepto }) => idConcepto))];

          conceptosIds.forEach((id) => {
            const conceptos = avancesFisicos
              .filter(({ idConcepto }) => idConcepto === id)
              .sort((a, b) => new Date(`${b.fecha}T00:00:00Z`) - new Date(`${a.fecha}T00:00:00Z`));

            ultimosConceptosReportados.push(conceptos[0]);
          });

          return {
            ...contrato,
            ultimosConceptosReportados,
          };
        })
        .map((contrato) => {
          const {
            estimaciones, ultimosConceptosReportados, importe, modificado,
          } = contrato;

          const importeEstimado = this.$ObjSumar(estimaciones, 'importeEstimado');
          const importeAvanceFisico = this.$ObjSumar(ultimosConceptosReportados, 'importe');

          const totalDeAvance = (importeEstimado + importeAvanceFisico);

          const totalContratado = (importe + modificado.importe);

          const porcentajeAvanceFinanciero = this.$numberRound(
            ((importeEstimado / totalContratado)) * 100,
          ) || 0;

          const avance = this.$numberRound(((totalDeAvance / totalContratado) * 100));

          return {
            ...contrato,
            porcentajeAvanceFisico: avance || 0,
            porcentajeAvanceFinanciero,
          };
        });
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('consulta-contratos', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('consulta-contratos');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">

</style>
